import React from 'react'
import KitchenConfigurationGrid from './KitchenConfigurationGrid'
import { SlotType } from './kitchenConfigurationHelper'
import { t } from '../../i18n'

const KitchenConfiguration = ({
  kitchenConfiguration,
  setKitchenConfiguration,
  kitchenConfigurationOptions,
  kitchenConfigurationErrors,
  setKitchenConfigurationErrors
}) => {

  const configuration = (slotType: SlotType) => {
    const fridgeColumns = slotType == SlotType.FIXED_CONTAINER ? 5 : 0

    return (
      <KitchenConfigurationGrid
        key={slotType}
        slotType={slotType}
        activeFields = {kitchenConfiguration[slotType]}
        kitchenConfigurationOptions={kitchenConfigurationOptions}
        kitchenConfigurationErrors={kitchenConfigurationErrors}
        setKitchenConfigurationErrors={setKitchenConfigurationErrors}
        fridgeColumns = {fridgeColumns}
        setActiveFields = {
          (activeFields) => setKitchenConfiguration({
            ...kitchenConfiguration,
            [slotType]: activeFields
          })
        }
      />
    )
  }

  return (
    <div className="kitchen-configuration mb-5">
      <h4 className="heading mb-4">{t('locations.kitchen_configuration.heading')}</h4>
      {Object.values(SlotType).map((slotType) => configuration(slotType))}
    </div>
  )
}

export default KitchenConfiguration
